import { render, staticRenderFns } from "./view-paper-dialog.vue?vue&type=template&id=6d8a60cc&scoped=true"
import script from "./view-paper-dialog.vue?vue&type=script&lang=js"
export * from "./view-paper-dialog.vue?vue&type=script&lang=js"
import style0 from "./view-paper-dialog.vue?vue&type=style&index=0&id=6d8a60cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8a60cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d8a60cc')) {
      api.createRecord('6d8a60cc', component.options)
    } else {
      api.reload('6d8a60cc', component.options)
    }
    module.hot.accept("./view-paper-dialog.vue?vue&type=template&id=6d8a60cc&scoped=true", function () {
      api.rerender('6d8a60cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/se/view/view-paper-dialog.vue"
export default component.exports